import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from '@/lib/axios'
import { getErrorMessage } from '@/lib/utils'
import { SystemSettingsParams } from '@/types/setting'

type SystemSettingsStateType = {
  isLoading: boolean
  error: {
    status?: number
    message: string
  } | null
}

type SystemSettingsStoreType = {
  systemSettingsState: SystemSettingsStateType
  applySystemSettings: (params: SystemSettingsParams) => Promise<void>
  reset: () => void
}

const initialState: SystemSettingsStateType = {
  isLoading: false,
  error: null
}

const useSystemSettingsStore = create<SystemSettingsStoreType>()(
  devtools(set => ({
    systemSettingsState: initialState,
    applySystemSettings: async (params: SystemSettingsParams) => {
      set(() => ({
        systemSettingsState: {
          ...initialState,
          isLoading: true
        }
      }))

      try {
        await axios.post('/admin/settings/system', params)
        set(() => ({
          systemSettingsState: initialState
        }))
      } catch (error: any) {
        set(() => ({
          systemSettingsState: {
            ...initialState,
            error: {
              status: error.response?.status || 500,
              message: getErrorMessage(error)
            }
          }
        }))

        throw error
      }
    },
    reset: () => {
      set(() => ({
        systemSettingsState: initialState
      }))
    }
  }))
)

export default useSystemSettingsStore
